<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="选择 Bom"
      id-key="UserId"
      :data="data"
      in-dialog
      @close-saved="$emit('close-saved')"
    >
      <el-table
        border
        class="table_bottom table-line tb-c-head"
        :data="tableData"
      >
        <el-table-column type="expand">
          <template slot-scope="{ $index }">
            <el-table
              border
              class="table_bottom table-line tb-c-head"
              :data="tableData[$index].child"
              type="selection"
              @selection-change="handleSelectionChange($event, $index)"
            >
              <el-table-column type="selection"> </el-table-column>
              <el-table-column
                v-for="item in innerColumns"
                :key="item.key"
                :prop="item.prop"
                :min-width="item.minWidth || 100"
                :label="item.lable"
                align="center"
              >
                <template slot-scope="{ row }">
                  <el-button
                    v-if="item.prop === 'Imgs'"
                    type="text"
                    @click="viewImg(row)"
                    >查看</el-button
                  >
                  <span v-else-if="item.prop === 'ProcessStage'">{{
                    (() => {
                      if (row.ProcessStage === 4) {
                        return "组合";
                      } else if (row.ProcessStage === 3) {
                        return "装配";
                      } else if (row.ProcessStage === 2) {
                        return "配件";
                      } else if (row.ProcessStage === 1) {
                        return "注塑";
                      } else if (row.ProcessStage === 0) {
                        return "无";
                      }
                    })()
                  }}</span>
                  <span v-else>{{ row[item.key] }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in columns"
          :key="item.key"
          :prop="item.prop"
          :min-width="item.minWidth || 100"
          :label="item.lable"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-button
              v-if="item.prop === 'Imgs'"
              type="text"
              @click="viewImg(row)"
              >查看</el-button
            >
            <span v-else-if="item.prop === 'ProcessStage'">{{
              (() => {
                if (row.ProcessStage === 4) {
                  return "组合";
                } else if (row.ProcessStage === 3) {
                  return "装配";
                } else if (row.ProcessStage === 2) {
                  return "配件";
                } else if (row.ProcessStage === 1) {
                  return "注塑";
                } else if (row.ProcessStage === 0) {
                  return "无";
                }
              })()
            }}</span>
            <span v-else>{{ row[item.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
      </template>
      <img-dialog ref="imgDialog" :imgs="imgs" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import imgDialog from "@/components/production/craftsmanship/bom/imgDialog";
import { urlHttp } from '@/components/production/craftsmanship/bom/bomConfig'

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    imgDialog,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    innerColumns: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      data: {},
      tableData: [],
      tempList: {},
      api: require("@/api/production/teMouldBom").default,
      imgs: [],
      pdApi: require("@/api/ba/product").default,
      pdList: [],
      selectBom:'',
      selectBomId:0
    };
  },
  created() {

    this.pdApi.list({ Status: 1 }).then((res) => {
      if (res.Code === 0) {
        this.pdList = res.Data;
       // localStorage.setItem('productListAll', JSON.stringify(this.pdList))
      }
    });
   
  },

  methods: {
    getList(type, MouldId) {
      console.log("type", type);

      this.tempList = {};

      if (type === 0) {
        this.api.getList({ MouldId: MouldId }).then((res) => {
          if (res.Code === 0) {
            let arr = [];
            res.Data.forEach((item) => {
              let { DetailDtos, ...list } = item;
              let o = {
                ...list,
                child: DetailDtos,
              };

              arr.push(o);
            });

            this.tableData = arr
          }
        });
      }
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(",");
    //   imgs.forEach((item) => {
    //     item = urlHttp + item;
    //   });

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    handleSelectionChange(list, index) {
      this.tempList["_" + index] = list;
      this.selectBom =this.tableData[index].Bomno
      this.selectBomId =this.tableData[index].TemouldBomId
    },
    getColors(ProductId) {
      let ids = this.pdList.map((item) => {
        return item.ProductId;
      });

      let index = ids.indexOf(ProductId);

      return this.pdList[index].Colors;
    },
    get_data(data) {
      let arr = [];
      data.forEach((item) => {
        let {
          BomType,
          ColorId,
          ColorName,
          ImgUrl,
          Imgs,
          PdUnitId,
          PdUnitName,
          UseColor,
          UseProcess,
          ProductName,
          ProductNo,
          ProcessStage,
          ProduceTypeName,
          ProductId,
          ProductSpec,
          Property,
          Quantity,
          Remarks,
          T,
          TeProductDetailId,
          TebomId,
          TespecialBomId,
          WarehouseId
        } = item;
        T = 0;

        let Colors = this.getColors(ProductId);

        let o = {
          BomType,
          ColorId,
          ColorName,
          ImgUrl,
          Imgs,
          PdUnitId,
          PdUnitName,
          ProductName,
          ProductNo,
          UseColor,
          UseProcess,
          ProcessStage,
          ProduceTypeName,
          ProductId,
          ProductSpec,
          Property,
          Quantity,
          Remarks,
          T,
          TeProductDetailId,
          TebomId,
          TespecialBomId,
          Colors,
          WarehouseId
        };

        arr.push(o);
      });

      return arr;
    },
    save() {
      console.log(this.tempList,'this.tempList')
      let list = [];
      let Bomno =''
      for (let item in this.tempList) {
        let _item = this.get_data(this.tempList[item]);
        Bomno=this.tempList[item][0].Bomno
        list.push(..._item);
      }
     
      this.$emit("saved", list, this.item,this.selectBom,this.selectBomId);
      
      console.log("list", list, "item", this.item);
      this.close();
    },
  },
};
</script>
